import PropTypes from 'prop-types'
import React from 'react'
import { isJsonString } from 'src/utils/Utils'

export const Item = ({property, value, unit}) => (
  <li>
    <p>{property}:</p>
    <span>
      {isJsonString(value) && Array.isArray(JSON.parse(value))
        ? JSON.parse(value).join(', ') : value}{unit}</span>
  </li>
)

Item.propTypes = {
  property: PropTypes.string,
  value: PropTypes.string,
  unit: PropTypes.string
}
